import { render, staticRenderFns } from "./admin-red-chirp-sso-settings.vue?vue&type=template&id=dfcb0a72&scoped=true&"
import script from "./admin-red-chirp-sso-settings.vue?vue&type=script&lang=js&"
export * from "./admin-red-chirp-sso-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcb0a72",
  null
  
)

export default component.exports